import store from "../store";

export async function userAuthenticate(to, from, next) {
    if (to.name === 'MatchFound') {
        return next();
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const encryptedMsisdn = urlSearchParams.get('e-msisdn');
    const allowedRoutes = ['QuestionScreen', 'MatchFound'];

    if (encryptedMsisdn) {
        const params = Object.fromEntries(urlSearchParams);
        store.commit('setUrlParameters', params);
        return next({name: 'MatchFound'});
    }

    if (allowedRoutes.includes(to.name)) {
        if (!store.state.urlParameters) {
            const params = Object.fromEntries(urlSearchParams);
            store.commit('setUrlParameters', params);
        }
        return next();
    }

    return next({name: 'QuestionScreen'});
}